import {ReactNode} from 'react'
import Table from '@mui/material/Table'
import {Box} from '@mui/material'

export interface ControlledFilterTableProps {
  children?: ReactNode
}

export const ControlledFilterTable = ({children}: ControlledFilterTableProps) => {
  return (
    <Box sx={{overflow: 'auto'}}>
      <Table sx={{minWidth: 650}}>{children}</Table>
    </Box>
  )
}

export interface ControlledFilterTableBaseColumn<T> {
  field: string
  label: string
  sortField?: string
  sortable?: boolean
  hideable?: boolean
  className?: string
  render?: (props: {data: T; rowIndex: number}) => ReactNode
  align?: 'center' | 'left' | 'right'
}

export type TableRowId = number | string

/**
 * First item is the key of the column.
 * Second item determines if the column is Ascending.
 * */
export type SortValue = [string, boolean]
